import React from 'react';


class Footer extends React.Component {
    render() {
      return (
        
        <footer>
            <p>Contact with me!</p>
            <p>
                &copy; Created for
                Angie Eslava
            </p>
        </footer>
      );
    }
  }
export default Footer;
  